import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../components/nadaConsta";



export const CeisPo = ({ceisPo}: {ceisPo: any}) => {
  const { t } = useTranslation();
  const sancoes = Array.isArray(ceisPo) ? ceisPo : [];

  return (
    <div style={{ width: "98%" }}>
      <Panel header={t('ceisPo')}>
        {ceisPo.message ? (<p>{ceisPo.message}</p>) : sancoes.length === 0 ? (<NadaConsta />) : (
          <DataTable size="small" value={sancoes} tableStyle={{ minWidth: '50rem' }}>
            <Column field="sancionado.nome" header="Sancionado"></Column>
            <Column field="sancionado.codigoFormatado" header="Documento"></Column>
            <Column field="tipoSancao.descricaoResumida" header="Sanção"></Column>
            <Column field="dataInicioSancao" header="Início Sanção"></Column>
            <Column field="dataFimSancao" header="Fim Sanção"></Column>
            <Column field="orgaoSancionador.nome" header="Órgão Sancionador"></Column>
            <Column field="orgaoSancionador.siglaUf" header="UF"></Column>
            <Column field="fonteSancao.nomeExibicao" header="Fonte"></Column>
            <Column field="numeroProcesso" header="Processo"></Column>
          </DataTable>
        )}
      </Panel>

    </div>
  );
};
